"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var AllowedIntents = {
  CONVERSATIONS: 'CONVERSATIONS',
  DOCUMENTS: 'DOCUMENTS',
  FORMS: 'FORMS',
  LEAD_FLOWS: 'LEAD_FLOWS',
  LEARNING_CENTER: 'LEARNING_CENTER',
  LANDING_PAGES: 'LANDING_PAGES',
  MARKETING_ADS: 'MARKETING_ADS',
  MARKETING_FREE_EMAIL: 'MARKETING_FREE_EMAIL',
  MEETINGS: 'MEETINGS',
  SALES_FREE: 'SALES_FREE',
  SALES_O365: 'SALES_O365',
  SALES_VSTO: 'SALES_VSTO',
  TRIAL: 'TRIAL',
  COMPANY_GRADER: 'COMPANY_GRADER',
  HUBSPOT_NETWORK: 'HUBSPOT_NETWORK'
};
var _default = AllowedIntents;
exports.default = _default;
module.exports = exports.default;